import api from '@/api'
import router from '@/router'

// State
const state = {
  configError: null,
  connected: false,
  mac: null,
  serial: null,
  fw: null,
  ip: null,
  modelName: null,
  powerMode: null,
  isIdentified: false,
  initKey: 0
}

// Gettetrs
const getters = {
  configError: state => state.configError,
  connected: state => state.connected,
  mac: state => state.mac,
  fw: state => state.fw,
  ip: state => state.ip,
  modelName: state => state.modelName,
  serial: state => state.serial,
  powerMode: state => state.powerMode,
  isIdentified: state => state.isIdentified,
  initKey: state => state.initKey
}

// Actions
const actions = {
  checkIdentity({ commit, dispatch }) {
    console.log('[BergOS][API] checkIdentity - Pending: ' + state.mac)
    api
      .checkIdentity(state.mac, state.serial)
      .then(response => {
        if (response.data === -1) {
          router.push({ name: 'InitialKey' })
          console.log('[BergOS][API] checkIdentity - Success: NO IDENTITY')
        } else {
          commit('IDENTIFY_DEVICE')
          dispatch('getDeviceInSystem')
          dispatch('setInitData')
        }
      })
      .catch(error => {
        console.error('[BergOS][API] checkIdentity - Error: ' + (error.response ? error.response.data.message : error))
        setTimeout(() => {
          dispatch('checkIdentity')
        }, 5000)
      })
  },
  getDeviceInSystem({ commit, dispatch }) {
    console.log('[BergOS][API] getDeviceInSystem - Pending: ' + state.mac)
    api
      .getDevice(state.mac, state.serial)
      .then(({ data }) => {
        console.log('[BergOS][API] getDeviceInSystem - Success!')
        Object.keys(data).forEach(o => {
          window.BtDevice[o] = data[o]
        })
        if (data.tvAppId) {
          dispatch('app/getAppById', data.tvAppId, { root: true })
        } else {
          commit('SET_CONFIG_ERROR', 'NO_APP')
          setTimeout(() => {
            dispatch('getDeviceInSystem')
          }, 5000)
        }
        dispatch('getDeviceStatus')
      })
      .catch(error => {
        console.error('[BergOS][API] getDeviceInSystem - Error: ' + (error.response ? error.response.data.message : error))
        setTimeout(() => {
          dispatch('getDeviceInSystem')
        }, 5000)
        dispatch('getDeviceStatus')
      })
  },
  getDeviceHardware({ commit, dispatch }) {
    function setDemoDevice() {
      const demoDevice = {
        serialNumber: 'DEMO_SERIAL_1',
        firmwareVersion: 'DEMO_FW_1',
        modelName: 'DEMO_MODEL_1',
        mac: 'DEMO_MAC_DEV_1',
        ip: 'DEMO_IP_1'
      }
      window.BtDevice = demoDevice
      commit('SET_SERIAL_NUMBER', demoDevice.serialNumber)
      commit('SET_FW_VERSION', demoDevice.firmwareVersion)
      commit('SET_MODEL_NAME', demoDevice.modelName)
      commit('SET_MAC', demoDevice.mac)
      commit('SET_IP', demoDevice.ip)
    }
    function setDevice(data) {
      commit('SET_SERIAL_NUMBER', data.serialNumber)
      commit('SET_FW_VERSION', data.firmwareVersion)
      commit('SET_MODEL_NAME', data.modelName)
      commit('SET_MAC', data.mac)
      commit('SET_IP', data.ip)
    }
    if (window.BtDevice) {
      const deviceData = window.BtDevice.getDevice()
      const deviceDataParsed = typeof deviceData === 'string' ? JSON.parse(deviceData) : deviceData

      if (typeof deviceData === 'string') {
        setDevice(deviceDataParsed)
        dispatch('checkIdentity')
      } else {
        deviceDataParsed.then(response => {
          setDevice(response)
          dispatch('checkIdentity')
        })
      }
    } else {
      console.error('[BergOS][DEVICE] Please connect with BergOS Client via Native Container - starting with demo data...')
      setDemoDevice()
      dispatch('checkIdentity')
    }
  },
  getDeviceStatus({ commit, state }) {
    if (window.BtDevice) {
      try {
        window.BtDevice.getPowerMode()
          .then(mode => {
            commit('SET_POWER_MODE', mode)
            console.error(`[BergOS][DEVICE] getDeviceStatus - Success - ${mode}`)
            this._vm.$socket.emit('device', {
              type: 'client',
              command: 'init',
              data: `{
              "mac": "${state.mac}",
              "status": "${mode}"
            }`
            })
          })
          .catch(() => {
            commit('SET_POWER_MODE', 'WARM')
          })
      } catch {
        console.error('[BergOS][DEVICE] getDeviceStatus - Error - using "WARM"')

        commit('SET_POWER_MODE', 'WARM')
        this._vm.$socket.emit('device', {
          type: 'client',
          command: 'init',
          data: `{
            "mac": "${state.mac}",
            "status": "WARM"
          }`
        })
      }
    }
  },
  setIdentity({ state, dispatch, commit }) {
    api
      .setIdentity({
        deviceType: 'DIGITAL_SIGNAGE',
        firmwareVersion: state.fw,
        mac: state.mac,
        serial: state.serial,
        ip: state.ip
      })
      .then(response => {
        console.log('[BergOS][API] setIdentity - Success: ' + response.data.sixDigitsKey)
        commit('SET_INIT_KEY', response.data.sixDigitsKey)
        dispatch('getDeviceInSystem')
      })
      .catch(error => {
        setTimeout(() => {
          dispatch('setIdentity')
        }, 3000)
        console.error('[BergOS][API] setIdentity - Error: ' + (error.response ? error.response.data.message : error))
      })
  },
  setInitData({ state, dispatch }) {
    api
      .setInitData(state.mac, state.fw, 'V0.00.00', state.ip, state.modelName)
      .then(() => {
        console.log(`[BergOS][API] setInitData - Success: ${state.mac} | ${state.fw} | ${'V0.00.00'} | ${state.ip} | ${state.modelName}`)
      })
      .catch(error => {
        console.error('[BergOS][API] setInitData - Error: ' + (error.response ? error.response.data.message : error))
        setTimeout(() => {
          dispatch('setInitData')
        }, 5000)
      })
    // dispatch('sendDeviceStatus')
  },
  socket_connect({ dispatch }) {
    console.log('[BergOS][SOCKET.IO] Connected!')
    dispatch('getDeviceStatus')
    setInterval(() => {
      dispatch('getDeviceStatus')
    }, 15 * 60 * 1000)
  },
  socket_device({ dispatch }, payload) {
    if (payload.command === 'action') {
      const data = JSON.parse(payload.data)
      const action = data.action
      console.log(`[BergOS][SOCKET.IO] Action: ${action}`)
      if (action === 'getStatus') {
        dispatch('getDeviceStatus')
      } else {
        try {
          if (action === 'setPowerWarm' || action === 'setPowerNormal') {
            window.BtDevice[action]
              .call()
              .then(() => {
                dispatch('getDeviceStatus')
              })
              .catch(() => {})
          } else {
            window.BtDevice[action].call()
          }
        } catch (err) {
          console.error(`[BergOS][SOCKET.IO] Action: "${action}" is not available!`)
        }
      }
    }
  }
}

// Mutations
const mutations = {
  SET_CONFIG_ERROR(state, value) {
    state.configError = value
  },
  SET_MAC(state, value) {
    state.mac = value
    console.log(`[BergOS][STORE] SET_MAC: ${value}`)
  },
  SET_IP(state, value) {
    state.ip = value
    console.log(`[BergOS][STORE] SET_IP: ${value}`)
  },
  SET_MODEL_NAME(state, value) {
    state.modelName = value
    console.log(`[BergOS][STORE] SET_MODEL_NAME: ${value}`)
  },
  SET_FW_VERSION(state, value) {
    state.fw = value
    console.log(`[BergOS][STORE] SET_FW_VERSION: ${value}`)
  },
  SET_SERIAL_NUMBER(state, value) {
    state.serial = value
    console.log(`[BergOS][STORE] SET_SERIAL_NUMBER: ${value}`)
  },
  SET_POWER_MODE(state, value) {
    state.powerMode = value
  },
  SET_INIT_KEY(state, value) {
    state.initKey = value
    console.log(`[BergOS][STORE] SET_INIT_KEY: ${value}`)
  },
  IDENTIFY_DEVICE(state) {
    state.isIdentified = true
  },
  SOCKET_CONNECT(state) {
    state.connected = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
